import React, { useState } from "react";

const Support = () => {
  const [activeTab, setActiveTab] = useState("faq");
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [ticketSubject, setTicketSubject] = useState("");
  const [ticketMessage, setTicketMessage] = useState("");
  const [ticketType, setTicketType] = useState("general");

  // FAQ Data
  const faqs = [
    {
      id: 1,
      question: "How do I fund my wallet?",
      answer: "You can fund your wallet by transferring to your dedicated virtual account number. The funds will be credited instantly to your wallet."
    },
    {
      id: 2,
      question: "What happens if my transaction fails?",
      answer: "If your transaction fails, the amount will be automatically refunded to your wallet within 24 hours. You can also contact our support team for immediate assistance."
    },
    {
      id: 3,
      question: "How do I buy airtime or data?",
      answer: "Simply select the service you want from the dashboard, enter the required details, and confirm the transaction. The service will be delivered instantly."
    },
    {
      id: 4,
      question: "Is there a transaction limit?",
      answer: "Yes, there are daily transaction limits based on your account tier. Premium users have higher limits."
    },
    // Add more FAQs as needed
  ];

  const handleTicketSubmit = (e) => {
    e.preventDefault();
    // Handle ticket submission logic
    console.log({ ticketType, ticketSubject, ticketMessage });
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Support Header */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-2xl font-semibold text-navy">Customer Support</h2>
        <p className="text-charcoal-gray mt-2">How can we help you today?</p>
      </div>

      {/* Support Navigation */}
      <div className="bg-white rounded-lg shadow-md mb-6">
        <div className="flex border-b border-light-gray">
          <button
            onClick={() => setActiveTab("faq")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "faq"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            FAQs
          </button>
          <button
            onClick={() => setActiveTab("ticket")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "ticket"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            Submit Ticket
          </button>
          <button
            onClick={() => setActiveTab("contact")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "contact"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Support Content */}
      <div className="bg-white rounded-lg shadow-md p-6">
        {activeTab === "faq" && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-navy mb-6">Frequently Asked Questions</h3>
            {faqs.map((faq) => (
              <div key={faq.id} className="border-b border-light-gray last:border-0">
                <button
                  onClick={() => setSelectedFaq(selectedFaq === faq.id ? null : faq.id)}
                  className="w-full py-4 flex items-center justify-between text-left"
                >
                  <span className="text-navy font-medium">{faq.question}</span>
                  <span className="material-icons text-charcoal-gray">
                    {selectedFaq === faq.id ? "remove" : "add"}
                  </span>
                </button>
                {selectedFaq === faq.id && (
                  <p className="text-charcoal-gray pb-4">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        )}

        {activeTab === "ticket" && (
          <div>
            <h3 className="text-lg font-semibold text-navy mb-6">Submit a Support Ticket</h3>
            <form onSubmit={handleTicketSubmit} className="space-y-6">
              <div>
                <label className="block text-charcoal-gray mb-2">Ticket Type</label>
                <select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                >
                  <option value="general">General Inquiry</option>
                  <option value="technical">Technical Issue</option>
                  <option value="billing">Billing Issue</option>
                  <option value="transaction">Transaction Issue</option>
                </select>
              </div>
              <div>
                <label className="block text-charcoal-gray mb-2">Subject</label>
                <input
                  type="text"
                  value={ticketSubject}
                  onChange={(e) => setTicketSubject(e.target.value)}
                  className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                  placeholder="Brief description of your issue"
                />
              </div>
              <div>
                <label className="block text-charcoal-gray mb-2">Message</label>
                <textarea
                  value={ticketMessage}
                  onChange={(e) => setTicketMessage(e.target.value)}
                  rows={6}
                  className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                  placeholder="Please provide details about your issue"
                ></textarea>
              </div>
              <button
                type="submit"
                className="bg-emerald-green hover:bg-opacity-90 text-white px-6 py-3 rounded-lg transition-colors duration-200"
              >
                Submit Ticket
              </button>
            </form>
          </div>
        )}

        {activeTab === "contact" && (
          <div>
            <h3 className="text-lg font-semibold text-navy mb-6">Contact Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Phone Support */}
              <div className="bg-soft-white p-6 rounded-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="material-icons text-emerald-green text-2xl">phone</span>
                  <h4 className="text-navy font-medium">Phone Support</h4>
                </div>
                <p className="text-charcoal-gray mb-2">Available 24/7</p>
                <p className="text-navy font-medium">+234 9075600297</p>
              </div>

              {/* Email Support */}
              <div className="bg-soft-white p-6 rounded-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="material-icons text-emerald-green text-2xl">email</span>
                  <h4 className="text-navy font-medium">Email Support</h4>
                </div>
                <p className="text-charcoal-gray mb-2">Response within 24 hours</p>
                <p className="text-navy font-medium">paysub@gmail.com</p>
              </div>

              {/* WhatsApp Support */}
              <div className="bg-soft-white p-6 rounded-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="material-icons text-emerald-green text-2xl">chat</span>
                  <h4 className="text-navy font-medium">WhatsApp Support</h4>
                </div>
                <p className="text-charcoal-gray mb-2">Quick Response</p>
                <p className="text-navy font-medium">+234 9075600297</p>
              </div>

              {/* Office Address */}
              <div className="bg-soft-white p-6 rounded-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="material-icons text-emerald-green text-2xl">location_on</span>
                  <h4 className="text-navy font-medium">Office Address</h4>
                </div>
                <p className="text-charcoal-gray">
                  123 Business Avenue<br />
                  Victoria Island<br />
                  Lagos, Nigeria
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Live Chat Button */}
      <button className="fixed bottom-6 right-6 bg-emerald-green text-white p-4 rounded-full shadow-lg hover:bg-opacity-90 transition-colors duration-200">
        <span className="material-icons">chat</span>
      </button>
    </div>
  );
};

export default Support;